// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15831","textarea":"styles_textarea__3tgj1"};